module.exports = __webpack_public_path__ + "museosans_500_italic-webfont.8a4796fc9b6c02c3f102.woff";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/museosans_500_italic-webfont.woff
// module id = ../../../../../src/assets/fonts/museosans_500_italic-webfont.woff
// module chunks = styles